import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "./storage"; // ⬅️ use safe storage, not direct "redux-persist/lib/storage"

// reducers...
import globalLoaderReducer from "./globalLoaderSlice";
import hospitalReducer from "./hospitalSlice";
import hospitalUsersReducer from "./hospitalusersSlice";
import userReducer from "./edituserSlice";
import patientuserReducer from "./PatientSlice";
import AppointmentReducer from "./AppointmentSlice";
import authReducer from "./authSlice";
import hospitalSelectionReducer from "./HospitalBranchSelectionSlice";
import hospitalAccessRightReducer from "./LoginAccessRightSlice";
import HospitalPrintSettingsReducer from "./HospitalPrintSettingsSlice"

const rootReducer = combineReducers({
  globalLoader: globalLoaderReducer,
  hospital: hospitalReducer,
  hospitalUsers: hospitalUsersReducer,
  user: userReducer,
  patientData: patientuserReducer,
  AppointmentData: AppointmentReducer,
  auth: authReducer,
  hospitalSelection: hospitalSelectionReducer,
  hospitalAccessRight: hospitalAccessRightReducer,
  HospitalPrintSettings: HospitalPrintSettingsReducer

});

const persistConfig = {
  key: "lightningq_app",
  storage,
  whitelist: ["auth", "hospitalSelection", "hospitalAccessRight","HospitalPrintSettings"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false, 
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
